import CryptoJS from "crypto-js";
import { Copies } from "shared/hooks/useCopies";
import { Dimension } from "shared/types/Dimension";
import { SizeType } from "./enum";
import I18n from "../../../types/I18n";

export function getMD5(str: string) {
  return CryptoJS.MD5(CryptoJS.enc.Latin1.parse(str)).toString();
}

export function getInstructionsForImageUpload({
  copies,
  maxSize,
  sizeType = SizeType.KB,
  aspectRatio,
  dimension,
  acceptedFileTypes,
  supportedFormatCopyKey = "supported.formats"
}: {
  copies: Copies;
  maxSize: number;
  sizeType?: string;
  aspectRatio?: string;
  dimension?: Dimension;
  acceptedFileTypes?: string | undefined;
  supportedFormatCopyKey?: keyof I18n;
}) {
  const supportedFormat = copies.get(supportedFormatCopyKey, { 0: acceptedFileTypes });
  const maximumSize = copies.get("maximum.allowed.filesize", {
    0: `${maxSize}${sizeType}`
  });

  if (aspectRatio && dimension) {
    aspectRatio = copies.get("recommended.aspectratio.dimension", {
      0: aspectRatio,
      1: `${dimension.width} x ${dimension.height}`
    });
  } else if (aspectRatio && !dimension) {
    aspectRatio = copies.get("recommended.aspect.ratio", {
      0: aspectRatio
    });
  } else if (!aspectRatio && dimension) {
    aspectRatio = copies.get("recommended.dimension", {
      0: `${dimension.width} x ${dimension.height}`
    });
  }

  return `${supportedFormat} ${maximumSize} ${aspectRatio || ""}`.trim();
}
